/* eslint-disable no-param-reassign */
import type { Module } from 'vuex';
import type { DeferRootState, PaydelaySignState } from '../constants';

export function getPayDelaySignModule(): Module<PaydelaySignState, DeferRootState> {
  return {
    namespaced: true,

    state: {
      /** 是否展示半页 */
      showHalfPage: true,
    },
    mutations: {
      setShowHalfPage(state, payload: { showHalfPage: boolean }): void {
        state.showHalfPage = payload.showHalfPage;
      },
    },
  };
}
